import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { ClubGate, RootRedirect } from "./contexts/ClubContext";
import Login from "./screens/Login";
import Register from "./screens/Register";
import Landing, { LANDING_PAGES } from "./screens/Landing";
import Beheer from "./screens/Beheer";
import ClubApp from "./screens/ClubApp";

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/aanmelden" element={<Register />} />
          <Route path="/beheer" element={<Beheer />} />
          <Route path="/" element={<RootRedirect guest={<Landing page="home" />} />} />
          <Route path="/voorbeeldles" element={<Navigate to="/demo" replace />} />
          {LANDING_PAGES.map(function (p) { return <Route key={p.key} path={p.path} element={<Landing page={p.key} />} />; })}
          <Route path="/:clubSlug" element={<ClubGate><ClubApp /></ClubGate>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
